<template>
  <v-app>

		<v-navigation-drawer
      v-model="mostrarMenú"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <!--<template v-for="item in items">
          <v-row
            v-if="item.heading"
            :key="item.heading"
            align="center"
          >
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col
              cols="6"
              class="text-center"
            >
              <a
                href="#!"
                class="body-2 black--text"
              >EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              link
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else
            :key="item.text"
            link
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>-->
				<v-list-item link v-for="(m, i) in menú" :key="`menu-${i}`" :to="m.ruta">
					<v-list-item-action>
						<v-icon>{{ m.ícono }}</v-icon>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item-title>
							{{ m.título }}
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
      </v-list>
    </v-navigation-drawer>

		<v-app-bar
			:clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="primary"
      dark
    >
      <!--<div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          transition="scale-transition"
          width="40"
        />

        <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png"
          width="100"
        />
      </div>-->

			<v-app-bar-nav-icon @click.stop="mostrarMenú = !mostrarMenú"></v-app-bar-nav-icon>

			<v-toolbar-title
        style="width: 500px"
        class="ml-0 pl-4"
      >
        <span class="hidden-sm-and-down">Eficiente: Terminal punto de venta - Administración</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

			<div>
        <span>{{ autenticación.cuenta.empresa.nombreLegal }}</span>
      </div>

			<v-menu bottom offset-y :close-on-content-click="false">
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon v-on="on" v-bind="attrs"><v-icon>mdi-dots-vertical</v-icon></v-btn>
				</template>

				<v-card>

					<v-progress-linear
						v-if="!autenticación.cargaInicial"
						color="deep-purple accent-4"
						indeterminate
						rounded
						height="6"
					></v-progress-linear>

					<v-card
						v-else-if="autenticación.cargaInicial && autenticación.usuario && autenticación.usuario.identificador && autenticación.cuenta && autenticación.cuenta.identificador"
						ccclass="pa-4"
					>
						
						<v-card-title class="text-h6 font-weight-regular">Hola, {{ autenticación.usuario.nombres }}</v-card-title>
						<v-card-subtitle>{{ autenticación.cuenta.empresa.nombreComercial }}</v-card-subtitle>

						<v-list>
							<v-list-item-group>
								<v-list-item @click="diálogoCuenta = true">
									<v-list-item-icon>
										<v-icon>mdi-lock-reset</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Cambiar contraseña</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item @click="autenticación.cerrar()">
									<v-list-item-icon>
										<v-icon>mdi-logout</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Cerrar sesión</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list-item-group>
						</v-list>

					</v-card>

					<div v-else><p>Error: 2398</p></div>

				</v-card>
			</v-menu>

      <!--<v-btn
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
        text
      >
        <span class="mr-2">Latest Release</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>-->
    </v-app-bar>

    <v-main style="background-color: #eee">

			<router-view class="pa-4"></router-view>

    </v-main>

		<v-dialog
			v-model="diálogoCuenta"
			max-width="700"
		>
			<cuenta @guardar="diálogoCuenta = false" @cancelar="diálogoCuenta = false"></cuenta>
		</v-dialog>

  </v-app>
</template>

<script>
import { autenticación } from '@/../../cliente_comun/fuentes.js'
import Tablero from '@/views/Tablero.vue'
import Cuenta from '@/components/cuenta.vue'

export default {
  name: 'Interfaz',
  components: {
		Tablero,
		Cuenta
	},
	data: function() {
		return {
			mostrarMenú: null,
			menú: [
				{
					ruta: '/',
					ícono: 'mdi-home',
					título: 'Inicio'
				},
				{
					ruta: '/productos',
					ícono: 'mdi-view-list',
					título: 'Productos'
				},
				{
					ruta: '/personas',
					ícono: 'mdi-card-account-details-outline',
					título: 'Personas'
				},
				{
					ruta: '/definiciones-de-impuestos',
					ícono: 'mdi-calculator',
					título: 'Definiciones de impuestos'
				},
				{
					ruta: '/facturas-de-compra',
					ícono: 'mdi-receipt',
					título: 'Facturas de compra'
				},
				{
					ruta: '/facturas-de-venta',
					ícono: 'mdi-receipt',
					título: 'Facturas de venta'
				},
				{
					ruta: '/puntos-de-venta',
					ícono: 'mdi-point-of-sale',
					título: 'PuntosDeVenta'
				},
				{
					ruta: '/usuarios',
					ícono: 'mdi-account-group',
					título: 'Usuarios'
				},
			],
			autenticación: autenticación,
			diálogoCuenta: false,
		}
	},
	methods: {
		//
	}
}
</script>
